import { Box, Container, Typography, styled } from '@mui/material';
import React from 'react';

const HeroWrapper = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',

  paddingBottom: '120px',
  backgroundColor: '#000000',
  backgroundImage: 'url("/assets/images/landing/hero-bg-new.jpg")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 0,
  },
}));

const ContentWrapper = styled(Container)({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
});

interface NewLandingHeroSectionProps {
  scrollToFeatures: () => void;
}

const NewLandingHeroSection: React.FC<NewLandingHeroSectionProps> = ({ scrollToFeatures }) => (
  <HeroWrapper className="landing-hero-section">
    <ContentWrapper maxWidth="lg">
      <Box
        sx={{
          maxWidth: '868px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: '16px', sm: '32px' },
          mt: { xs: 0, sm: 4 },
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Typography
            variant="landingH1"
            component="h1"
            color="landingPage.textPrimary"
            sx={{
              mb: { xs: 1, sm: 2 },
              color: '#FFFFFF',
              fontFamily: 'Nohemi',
              fontSize: { xs: '36px', sm: '48px', md: '64px' },
              fontWeight: 600,
              lineHeight: 1.2,
              letterSpacing: '0.02em',
              textAlign: 'center',
            }}
          >
            {/* AI-Powered Rental Property Manager */}
            Revolutionizing Property Management Through the Power of AI
          </Typography>

          <Typography
            variant="landingBody"
            sx={{
              mb: { xs: 0, sm: 4 },
              color: '#FFFFFF',
              fontSize: { xs: '16px', md: '20px' },
              fontWeight: 500,
              lineHeight: 1.4,
              textAlign: 'center',
            }}
          >
            Save time, reduce stress, and increase revenue with our AI-powered solution that handles
            all aspects of your rental property management.
            <br />
            Whether you're managing one home or hundreds of units, we're built to support you every
            step of the way.
          </Typography>
        </Box>

        {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center">
          <Button
            variant="outlined"
            sx={{
              borderRadius: '10px',
              color: '#FFFFFF',
              padding: '16px 22px',
              borderColor: '#FFFFFF',
              backgroundColor: 'transparent',
              '&:hover': {
                borderColor: '#FFFFFF',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
            startIcon={
              <Box
                component="img"
                src="/assets/icons/play-circle.svg"
                alt="Demo"
                sx={{ width: 24, height: 24 }}
              />
            }
          >
            Book a Demo
          </Button>

          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: '10px',
              padding: '16px 22px',
            }}
            onClick={scrollToFeatures}
          >
            About Us
          </Button>
        </Stack> */}
      </Box>
    </ContentWrapper>
  </HeroWrapper>
);

export default NewLandingHeroSection;
